
import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface LessonErrorDisplayProps {
  error: string | null;
}

const LessonErrorDisplay: React.FC<LessonErrorDisplayProps> = ({ error }) => {
  if (!error) return null;
  
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 text-center">
      <div className="flex items-center justify-center gap-2 text-red-700 mb-2">
        <AlertTriangle size={20} />
        <h3 className="font-medium">Error Loading Lesson</h3>
      </div>
      <p className="text-red-600">{error}</p>
    </div>
  );
};

export default LessonErrorDisplay;
